import { render, staticRenderFns } from "./StepPreNext.vue?vue&type=template&id=2263c620&scoped=true"
import script from "./StepPreNext.vue?vue&type=script&lang=js"
export * from "./StepPreNext.vue?vue&type=script&lang=js"
import style0 from "./StepPreNext.vue?vue&type=style&index=0&id=2263c620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263c620",
  null
  
)

export default component.exports